import "reflect-metadata";
import CoreApp, {ConfigHelper, IServiceConfig, ThemeVars} from "@athena-portal/core";
import theme from "./theme/theme.scss"
import {Layout} from "./Layout";
import {init as initApm} from "@elastic/apm-rum"
import FreeInsuranceRegistrationPage from "./pages/FreeInsuranceRegistrationPage";
import InsuranceContributionPage from "./pages/InsuranceContributionPage";
import {PromotionPortalLandingPage} from "./pages/PromotionPortalLandingPage";
import {IPromotionPortalService} from "./services/IPromotionPortalService";
import {Types} from "./Types";
import {PromotionPortalServiceImpl} from "./services/impl/PromotionPortalServiceImpl";
import {IFerryConvenienceApiService} from "./services/IFerryConvenienceApiService";
import {FerryConvenienceApiServiceImpl} from "./services/impl/FerryConvenienceApiServiceImpl";

if (process.env.REACT_APP_APM_SERVER_ENABLED?.toString() === "true") {
    initApm({
        serviceName: process.env.REACT_APP_APPLICATION_NAME,
        serverUrl: process.env.REACT_APP_APM_SERVER_URL,
        distributedTracingOrigins: process.env.REACT_APP_APM_DISTRIBUTED_TRACING_ORIGINS ? process.env.REACT_APP_APM_DISTRIBUTED_TRACING_ORIGINS.split(",") : [],
        serviceVersion: process.env.REACT_APP_APPLICATION_VERSION,
        propagateTracestate: true
    })
}

const app = new CoreApp();
const extensions = app.getExtensionPoints();

app.i18n().setAvailableLocales({
    "en-GB": {},
});

app.setTheme(theme as ThemeVars);

extensions.routes.add({
    path: "/",
    component: PromotionPortalLandingPage,
});

extensions.routes.add({
    path: "/promotion/free-insurance",
    component: FreeInsuranceRegistrationPage,
});

extensions.routes.add({
    path: "/promotion/insurance-contribution",
    component: InsuranceContributionPage,
});

const promotionPortalApiServiceConfig: IServiceConfig = {
    serviceBaseUrl: process.env.REACT_APP_FERRY_PROMOTION_PORTAL_API_BASE_URL || "",
    customQueryStringParameters: ConfigHelper.parseMapFromString(
        process.env.REACT_APP_FERRY_PROMOTION_PORTAL_API_CUSTOM_QUERY_STRING || ""
    ),
    customHeaders: ConfigHelper.parseMapFromString(
        process.env.REACT_APP_FERRY_PROMOTION_PORTAL_API_CUSTOM_HEADERS || ""
    )
};

const ferryConvenienceApiServiceConfig: IServiceConfig = {
    serviceBaseUrl: process.env.REACT_APP_FERRY_CONVENIENCE_API_BASE_URL || "",
    customQueryStringParameters: ConfigHelper.parseMapFromString(
        process.env.REACT_APP_FERRY_CONVENIENCE_API_CUSTOM_QUERY_STRING ? process.env.REACT_APP_FERRY_CONVENIENCE_API_CUSTOM_QUERY_STRING : ""
    ),
    customHeaders: ConfigHelper.parseMapFromString(
        process.env.REACT_APP_FERRY_CONVENIENCE_API_CUSTOM_HEADERS ? process.env.REACT_APP_FERRY_CONVENIENCE_API_CUSTOM_HEADERS : ""
    )
};


extensions.services.bind<IPromotionPortalService>(Types.PromotionPortalService).to(PromotionPortalServiceImpl);
extensions.services.bind<IServiceConfig>(Types.PromotionPortalServiceConfig).toConstantValue(promotionPortalApiServiceConfig);
extensions.services.bind<IFerryConvenienceApiService>(Types.FerryConvenienceApiService).to(FerryConvenienceApiServiceImpl);
extensions.services.bind<IServiceConfig>(Types.FerryConvenienceApiServiceConfig).toConstantValue(ferryConvenienceApiServiceConfig);


app.render(
    <Layout/>,
    document.getElementById("root") as HTMLElement
);
